import { convertToDate, defaultStartDate } from '@givelify/utils';
import dayjs from 'dayjs';
import { Donee, Onboarding } from '../models';

const mapResponseToDoneeOnboarding = (onboarding: Onboarding): Onboarding => {
    return {
        ...onboarding,
        midDateAdded: onboarding.midDateAdded
            ? convertToDate(onboarding.midDateAdded)
            : null,
        bankInfo: {
            ...onboarding.bankInfo,
            submittedAt: onboarding.bankInfo?.submittedAt
                ? convertToDate(onboarding.bankInfo.submittedAt)
                : null,
        },
        ein: {
            ...onboarding.ein,
            submittedAt: onboarding.ein?.submittedAt
                ? convertToDate(onboarding.ein.submittedAt)
                : null,
        },
        primaryRepresentative: {
            ...onboarding.primaryRepresentative,
            submittedAt: onboarding.primaryRepresentative?.submittedAt
                ? convertToDate(onboarding.primaryRepresentative.submittedAt)
                : null,
            dateOfBirth: onboarding.primaryRepresentative?.dateOfBirth
                ? dayjs(onboarding.primaryRepresentative.dateOfBirth)
                : null,
        },
    };
};

export const mapResponseToDonee = (donee: Donee): Donee => {
    return {
        ...donee,
        onboarding: donee.onboarding
            ? mapResponseToDoneeOnboarding(donee.onboarding)
            : donee.onboarding,
        createdAt: donee.createdAt
            ? convertToDate(donee.createdAt)
            : defaultStartDate,
        updatedAt: donee.updatedAt
            ? convertToDate(donee.updatedAt)
            : defaultStartDate,
        signupDate: donee.signupDate
            ? convertToDate(donee.signupDate)
            : defaultStartDate,
        lastDonationDate: donee.lastDonationDate
            ? convertToDate(donee.lastDonationDate)
            : null,
    };
};

export const mapResponseToCampuses = (donee: Donee): Donee[] => {
    const rawCampuses = donee.campuses;
    let result = [mapResponseToDonee(donee)];
    if (rawCampuses) {
        const campuses = rawCampuses.map((campus) => {
            return mapResponseToDonee(campus);
        });
        result = result.concat(campuses);
    }
    return result;
};
